/**
 * @generated SignedSource<<9674db57e7293e07da1fc212a13c9c5f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CancelBookingModal_Booking$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ModalStepOutlet_CancelBooking_Booking" | "useInitializeCancelBookingModal_Booking">;
  readonly " $fragmentType": "CancelBookingModal_Booking";
};
export type CancelBookingModal_Booking$key = {
  readonly " $data"?: CancelBookingModal_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"CancelBookingModal_Booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CancelBookingModal_Booking",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ModalStepOutlet_CancelBooking_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useInitializeCancelBookingModal_Booking"
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "0c537ebbaa1693539d9caaa793a75b98";

export default node;
